import { CompactUserResponse } from '../account';

export enum GCCalendarEventObjectType {
  Deal = 'deal',
  Organization = 'organization',
  Contact = 'conact',
  TimeMaterial = 'timeMaterial',
  TMPhase = 'tmPhase',
  Project = 'project',
}

export interface GCCalendarEventResponse {
  id: string;
  localEventId?: string;
  name: string;
  orgId: string;
  description?: string;
  location?: string;
  objectId?: string;
  objectName?: string;
  objectType?: GCCalendarEventObjectType;
  createdBy: CompactUserResponse;
  participants: Participant[];
  startTime: number;
  endTime: number;
  createdAt: number;
  updatedAt: number;
  isSynced: boolean;
  userIds?: string[];
  status: GCCalendarEventStatus;
  color?: string;
  strikeThrough: boolean;
  associatedValue?: number;
}

export interface Participant {
  id: string;
  eventId: string;
  userId?: string;
  email?: string;
  userType: string;
  user?: CompactUserResponse;
  acceptanceStatus: 'yes' | 'no' | 'maybe';
}

export type GCCalendarEventRequest = Omit<GCCalendarEventResponse, 'id' | 'createdAt' | 'updatedAt' | 'createdBy'>;

export enum GCCalendarEventStatus {
  accepted = 'accepted',
  declined = 'declined',
  rescheduled = 'rescheduled',
}

// get GCCalendarEventStatuses array
export const GCCalendarEventStatuses = Object.values(GCCalendarEventStatus);
